import {
  FetchHttpRequest,
  FetchRequestOptions,
  HttpException,
} from "http-repository-cache";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import CustomerAnalysisRepository from "@/core/customers/repositories/CustomerAnalysisRepository";
import {
  CustomerAnalysisResponse,
  CustomerAnalysisRequest,
} from "@/core/customers/entities/CustomerAnalysis";
import { getCustomerAnalysisUrl } from "../../api/customerAnalysisEndpoints/customerAnalysisEndpoints";
import { ApiResponse } from "../../api/types/ApiResponse";

export default class CustomerAnalysisRepositoryBackend
  implements CustomerAnalysisRepository
{
  constructor(
    private readonly httpRequest: FetchHttpRequest<FetchRequestOptions>
  ) {}

  async getCustomerAnalysis(
    request: CustomerAnalysisRequest
  ): Promise<CustomerAnalysisResponse> {
    try {
      const url = `${getCustomerAnalysisUrl()}/${request.businessKey}`;
      const response = await this.httpRequest.get<CustomerAnalysisResponse>({
        url,
      });
      return response;
    } catch (error) {
      throw handleRequestError(
        error as HttpException<unknown, unknown> | ApiResponse<unknown>
      );
    }
  }
}
